import * as types from 'constants/actionTypes';

export function updateCharts(chartsObject) {
  return {
    type: types.CHARTS_FOR_EXPORT,
    chartsObject
  };
}

export function updateYears(years) {
  return {
    type: types.YEARS_SELECTED,
    years
  };
}

export function initMap(container) {
  return {
    type: types.INIT_MAP,
    container
  };
}

export function updatePrecalculatedShapeName(shapeName) {
  return {
    type: types.PRECALCULATED_SHAPE,
    shapeName
  };
}

export function saveSnapshot(snapshot) {
  return {
    type: types.SAVE_SNAPSHOT,
    snapshot
  };
}

export function toggleAnalysis(bool) {
  return {
    type: types.SHOW_ANALYSIS,
    bool
  };
}

export function toggleDrawShapePanel(bool) {
  return {
    type: types.EXPAND_DRAW_SHAPE_PANEL,
    bool
  };
}

export function toggleLoader(status) {
  return {
    type: types.LOADER_ACTIVE,
    status
  };
}

export function toggleReport(bool) {
  return {
    type: types.REPORT_IS_AVAILABLE,
    bool
  };
}

export function toggleVisibleLayer(id) {
  return {
    type: types.TOGGLE_VISIBLE_LAYER,
    id
  };
}

export function clearCharts(bool) {
  return {
    type: types.CLEAR_CHARTS,
    bool
  };
}

export function updatePrecalculatedCSV(csvDataString) {
  return {
    type: types.PRECALCULATED_CSV_DATA,
    csvDataString
  };
}

export function toggleBasemapSelector(boolean) {
  return {
    type: types.TOGGLE_BASEMAP_SELECTOR,
    boolean
  };
}

export function updateTotalAreaForCSV(area) {
  return {
    type: types.TOTAL_AREA,
    area
  };
}

export function updateHistogramResults(histogramResults) {
  return {
    type: types.HISTOGRAM_RESULTS,
    histogramResults
  };
}

export function updateUserDrawnPolygon(geometry) {
  return {
    type: types.USER_DRAWN_POLYGON,
    geometry
  };
}

export function setMapLayers(layers) {
  return {
    type: types.SET_MAP_LAYERS,
    layers
  };
}
